import { enabledPageGuard } from '@/lib/migration';
import { permissaoGuard } from '@/lib/permissions';
import { createFileRoute } from '@tanstack/react-router';
import PrecosPageComponent from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/precos/',
)({
  beforeLoad: async () => {
    await enabledPageGuard('precos', {
      redirectToOldSitePage: 'comercial/produto/precos',
    });

    await permissaoGuard('Precos');
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <PrecosPageComponent />;
}
